<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height: 100%">
  <div style="box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 50%; flex-direction: column; place-content: stretch flex-start; align-items: stretch;">
    <div style="box-sizing: border-box; display: flex; flex: 1 1 100%; max-height: 5%"></div>

    <div style="box-sizing: border-box; display: flex; flex-direction: column; flex: 1 1 0%;">
      <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
        <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
          <div>Select Email Thread</div>
        </div>
      </mat-toolbar>
      <div style="max-height: 800px;">
        <mat-card appearance="outlined" style="height: 78vh;">
          <mat-card-content style="height: calc(100% - 80px); overflow: auto;">
            <mat-nav-list>
              @for (threadGroup of threadGroupings; track threadGroup) {
                <mat-list-item>
                  <a matListItemTitle class="threadGroupingLink lex-theme-font--classic" [routerLink]="['/review/browse']" [queryParams]="{ EmailThreadId: threadGroup.threadGroupingId }"
                    style="box-sizing: border-box; display: flex; height: 100%; place-content: center space-between; align-items: center;">
                    {{threadGroup.groupTitle}}
                  </a>
                  <div matListItemMeta class="lex-theme-font--classic">
                    {{threadGroup.docCount}}
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
              }
            </mat-nav-list>
          </mat-card-content>

          <mat-card-actions align="right">
            <mat-paginator class="density-neg-5"
                           [length]="totalEmailThreads"
                           [pageSize]="pageSize"
                           [pageSizeOptions]="pageSizeOptions">
            </mat-paginator>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>

    <div style="box-sizing: border-box; display: flex; flex: 1 1 100%; max-height: 5%;"></div>
  </div>
</div>
